import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿SAINT® reemplaza a los antidepresivos?",
    answer:
      "No. SAINT® es un tratamiento para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos. No reemplaza la medicación; su papel se evalúa en una consulta con el equipo clínico.",
  },
];

export const esSaintVsAntidepressants = makeEsArticle({
  slug: "saint-vs-antidepressants",
  title: "SAINT® frente a antidepresivos para la depresión",
  description:
    "Comparación de SAINT® TMS y los antidepresivos: cómo actúa cada uno, para quién está indicado SAINT® y por qué no es un reemplazo directo de la medicación.",
  h1: "SAINT® frente a antidepresivos",
  breadcrumbLabel: "SAINT® vs antidepresivos",
  shortAnswer:
    "Los antidepresivos actúan químicamente sobre el cerebro durante semanas o meses. SAINT® es un tratamiento con estimulación magnética que se administra en cinco días para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos. SAINT® no reemplaza la medicación; su papel en cada caso se evalúa en una consulta con el equipo clínico.",
  keyTakeaways: [
    "Los antidepresivos actúan químicamente durante semanas o meses.",
    "SAINT® es estimulación magnética administrada en cinco días.",
    "SAINT® está indicada para adultos que no han mejorado con antidepresivos.",
    "SAINT® no reemplaza la medicación.",
    "El papel de cada tratamiento se evalúa en una consulta.",
  ],
  sections: [
    {
      heading: "Cómo actúan los antidepresivos",
      paragraphs: [
        "Los antidepresivos actúan sobre la química del cerebro durante un período que suele ser de semanas o meses. Para muchas personas son eficaces; para otras, los síntomas no mejoran lo suficiente.",
      ],
    },
    {
      heading: "Cómo actúa SAINT®",
      paragraphs: [
        "SAINT® es una estimulación magnética transcraneal acelerada con orientación por fMRI que se administra en 50 sesiones durante cinco días. Está autorizada por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos.",
        "SAINT® no está indicada para ansiedad, trastorno bipolar, TEPT u otras condiciones, y no reemplaza la medicación. Si los antidepresivos no han funcionado lo suficiente, SAINT® puede ser una opción a evaluar en una consulta.",
      ],
    },
  ],
  faqs,
  sources: [
    {
      citation:
        "Cole EJ, et al. Stanford Accelerated Intelligent Neuromodulation Therapy for Treatment-Resistant Depression. Am J Psychiatry. 2020;177(8):716-726.",
      url: "https://doi.org/10.1176/appi.ajp.2019.19070720",
    },
  ],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
